import React from "react"
import PropTypes from "prop-types"

import _capitalize from "lodash/capitalize"
import _map from "lodash/map"

import ItemBody from "./ItemBody"
import IncidentDownloadContextMenu from "../IncidentDownloadContextMenu"

import {
  OSM,
  PROBLEM_SOLVED_AVAILABILITY_STATUS
} from "services/state/repair/constants"

const ProgressRequests = ({
  t,
  progressDemands,
  getDescription,
  loading,
  onShowDetailsProgress,
  onTrackTechnician,
  onShowProblemSolvedModal
}) => {
  const canShowProblemSolved = (demand) => {
    return (
      demand.system === OSM &&
      demand.worklistName === PROBLEM_SOLVED_AVAILABILITY_STATUS
    )
  }

  return _map(progressDemands, (demand) => {
    return (
      !loading &&
      demand && (
        <ItemBody
          key={demand.requestId}
          protocol={demand.protocolNumber}
          description={_capitalize(getDescription(demand))}
          onClickItem={() => onShowDetailsProgress(demand, "isOpenModalDetail")}
          type="progress"
          t={t}
          renderOthersColumns={() => (
            <td>
              {demand.cartTechnician || canShowProblemSolved(demand) ? (
                <form>
                  <IncidentDownloadContextMenu
                    onTrackTechnician={() => onTrackTechnician(demand)}
                    onShowProblemSolvedModal={() =>
                      onShowProblemSolvedModal(
                        demand,
                        "isOpenProblemSolvedModal"
                      )
                    }
                    showTrackTechnician={demand.cartTechnician}
                    showProblemSolved={canShowProblemSolved(demand)}
                  />
                </form>
              ) : null}
            </td>
          )}
        />
      )
    )
  })
}

ProgressRequests.propTypes = {
  t: PropTypes.func,
  progressDemands: PropTypes.array,
  getDescription: PropTypes.func,
  loading: PropTypes.bool,
  onShowDetailsProgress: PropTypes.func,
  onTrackTechnician: PropTypes.func,
  onShowProblemSolvedModal: PropTypes.func
}

export default ProgressRequests



// WEBPACK FOOTER //
// ./src/scenes/IncidentManager/components/Requests/ProgressRequests.js